import { render, staticRenderFns } from "./VitalSignType.vue?vue&type=template&id=2ad49066&"
import script from "./VitalSignType.vue?vue&type=script&lang=js&"
export * from "./VitalSignType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports